import Spinner from "Icons/Spinner";

export default function PageSpinner() {
  return (
    <div className="flex f-center">
      <Spinner width={50} height={50} />
    </div>
  );
}
